import { initialUserState, UserState } from '@store/state/user.state';
import { UserActions, EnumUserActions } from '@store/actions/user.action';

export function usersReducer(
    state = initialUserState,
    action: UserActions
): UserState {
    switch (action.type) {
        case EnumUserActions.SetUser: {
            return {
                ...state,
                profile: action.user
            };
        }
        case EnumUserActions.SetAlert: {
            return {
                ...state,
                alert: action.alerts,
                loaded: { ...state.loaded, alert: true }
            };
        }
        case EnumUserActions.SetFavorite: {
            return {
                ...state,
                favorite: action.favorites,
                loaded: { ...state.loaded, favorite: true }
            };
        }
        case EnumUserActions.SetNotification: {
            return {
                ...state,
                notification: action.notifications,
                loaded: { ...state.loaded, notification: true }
            };
        }
        case EnumUserActions.SetNotificationCounter: {
            return {
                ...state,
                notificationCounter: action.notificationCounter
            };
        }
        case EnumUserActions.SetSinalization: {
            return {
                ...state,
                sinalization: action.sinalizations,
                loaded: { ...state.loaded, sinalization: true }
            };
        }
        case EnumUserActions.HideOnboarding: {
            return {
                ...state,
                hideOnboarding: action.hide
            };
        }
        case EnumUserActions.UserDataFailed: {
            return {
                ...state,
                loaded: { ...state.loaded, [action.data]: true }
            };
        }
        default:
            return state;
    }
}
